header {
    @include typo-ws-h4-fixed;

    background-color: $color-grey-01-dark;
    color: $color-white;
    height: 60px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    padding: 0 15px 0 7px;

    .title {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
        grid-column: 2;
    }

    .back,
    .close {
        all: unset;
        cursor: pointer;
    }
}

.content {
    padding: 40px 32px;

    p {
        @include typo-ws-paragraph;

        margin: 0;
    }
}
